import { render, staticRenderFns } from "./SentimentPopular2.vue?vue&type=template&id=32eb2b62&scoped=true"
import script from "./SentimentPopular2.vue?vue&type=script&lang=js"
export * from "./SentimentPopular2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb2b62",
  null
  
)

export default component.exports